// The docked Insights chat is user-resizable. Width is kept between a readable
// minimum and a cap that also never lets the panel eat more than 60% of the
// viewport (so the report it sits beside stays usable on smaller screens).

export const INSIGHTS_CHAT_MIN_WIDTH = 360;
export const INSIGHTS_CHAT_MAX_WIDTH = 760;
export const INSIGHTS_CHAT_DEFAULT_WIDTH = 460;

const clampInsightsChatWidth = (
  width: number,
  viewportWidth: number = typeof window === 'undefined'
    ? INSIGHTS_CHAT_MAX_WIDTH
    : window.innerWidth,
): number => {
  // On a narrow viewport the 60% cap can fall below the minimum; keep the upper
  // bound at least the minimum so the result stays well-defined.
  const upperBound = Math.max(
    INSIGHTS_CHAT_MIN_WIDTH,
    Math.min(INSIGHTS_CHAT_MAX_WIDTH, Math.round(viewportWidth * 0.6)),
  );
  return Math.min(Math.max(width, INSIGHTS_CHAT_MIN_WIDTH), upperBound);
};

export default clampInsightsChatWidth;
